import commonService from "./CommonService";
import httpService from "./http";

const ApsServices = {
  common: commonService,
  http: httpService,
};

export default ApsServices;
